module.exports = __webpack_public_path__ + "media/images/landing/ar/planning@2x-72230e19c5ce888fb032d94180a1aa94.png";